import { Button, ImageIcon } from '@saleshandy/design-system';
import React, { memo, useCallback } from 'react';
import { debounce } from 'lodash';
import { AiSequenceModalFooterProps } from '../../../type';
import Checkbox from '../../../../../../../shared/design-system/components/atoms/checkbox';

/**
 *@description
 * AiSequenceModalFooter is a functional component that renders the footer of the AI sequence modal.
 * @param
 * validateContinuebtn: it is used to disable the continue button
 * ContinueSubmit: it is used to handle the continue button click event
 * @returns {JSX.Element} A footer with "Skip" and "Continue" buttons.
 */

const AiSequenceModalFooter: React.FC<AiSequenceModalFooterProps> = ({
  disableContinueBtn = false,
  disableSkipBtn = false,
  onClickContinue = () => {},
  onClickSkip = () => {},
  showSkipBtn = false,
  submitlabel = 'Continue',
  customClassName = '',
  imageSrc,
  isLoading = false,
  showCheckbox = false,
  checkboxLabel = '',
  isCheckboxChecked = false,
  onCheckboxChange = () => {},
  loadingText = '',
}) => {
  const debounceContinue = useCallback(
    debounce(() => {
      onClickContinue();
    }, 600),
    [onClickContinue],
  );
  const debounceSkip = useCallback(
    debounce(() => {
      onClickSkip();
    }, 600),
    [onClickSkip],
  );

  return (
    <div
      className={`ai-sequence-footer-container ${
        showSkipBtn || showCheckbox ? 'add-skip' : ''
      }`}
    >
      {showCheckbox && (
        <Checkbox
          checked={isCheckboxChecked}
          onChange={(checked) => onCheckboxChange(checked)}
          className="cursor-pointer"
          label={checkboxLabel}
        />
      )}
      {showSkipBtn && (
        <Button
          className="skip-btn"
          disabled={disableSkipBtn}
          onClick={debounceSkip}
        >
          Let AI Pick the Best
        </Button>
      )}
      <Button
        className={`continue-btn ${customClassName}`}
        disabled={disableContinueBtn}
        onClick={debounceContinue}
        isLoading={isLoading}
        loadingText={loadingText}
      >
        {imageSrc && <ImageIcon src={imageSrc} alt="star" />}
        {submitlabel}
      </Button>
    </div>
  );
};
export default memo(AiSequenceModalFooter);
